import { render, staticRenderFns } from "./Banner-Details.vue?vue&type=template&id=5a6c7e39&"
import script from "./Banner-Details.vue?vue&type=script&lang=js&"
export * from "./Banner-Details.vue?vue&type=script&lang=js&"
import style0 from "./Banner-Details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports